import { isPlatformBrowser } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import {
  EventComboTicket,
  EventComboTicketRequestBody,
} from "@models/combo-ticket";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { LocalStorageService } from "./local-storage.service";

@Injectable({
  providedIn: "root",
})
export class ComboTicketManagementService {
  private readonly apiUrl = environment.API_BACKEND;
  private readonly http = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly platformId = inject(PLATFORM_ID);

  private getHttpHeaders(): HttpHeaders {
    const token = isPlatformBrowser(this.platformId)
      ? this.localStorageService.getItem("auth-token")
      : null;
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  getComboTickets(eventId: number): Observable<EventComboTicket[]> {
    return this.http.get<EventComboTicket[]>(
      `${this.apiUrl}/events/${eventId}/combo_tickets`,
      { headers: this.getHttpHeaders() },
    );
  }

  createComboTicket(
    eventId: number,
    body: EventComboTicketRequestBody,
  ): Observable<EventComboTicket> {
    return this.http.post<EventComboTicket>(
      `${this.apiUrl}/events/${eventId}/combo_tickets`,
      body,
      { headers: this.getHttpHeaders() },
    );
  }

  updateComboTicket(
    comboId: number,
    body: EventComboTicketRequestBody,
  ): Observable<EventComboTicket> {
    return this.http.patch<EventComboTicket>(
      `${this.apiUrl}/combo_tickets/${comboId}`,
      body,
      { headers: this.getHttpHeaders() },
    );
  }

  deleteComboTicket(comboId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/combo_tickets/${comboId}`, {
      headers: this.getHttpHeaders(),
    });
  }
}
